module.exports = __webpack_public_path__ + "img/b_m@2x.513a9f34.png";